export const DEFAULT_DURATION_MS = 4000
export const MAX_VISIBLE = 5
